import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../hooks";
import AdminLayout from "../../pages/Admin/Layout";
import CashierLayout from "../../pages/Cashier/Layout";
import ManagerLayout from "../../pages/Manager/Layout";


export const RoleBasedLayout = ({ children }: { children: React.ReactNode }) => {
  const userRole = useAppSelector((state) => state.auth.activeRole);

  switch (userRole) {
    case "Manager":
      return <ManagerLayout>{children}</ManagerLayout>;
    case "Cashier":
      return <CashierLayout>{children}</CashierLayout>;
    case "Admin":
        return <AdminLayout>{children}</AdminLayout>
    default:
      return <Navigate to="/login" replace />; // or redirect to /unauthorized
  }
};
